






















































import Vue from 'vue'
import PoolsDetails from '@morpheus/procodes/admin-vue/components/PoolsDetails.vue'
import { fetchPoolById } from '@morpheus/procodes/admin-vue/services/procodes-client'
import { PoolShowData } from '@morpheus/procodes/admin-vue/types'
import PoolsCodes from '@morpheus/procodes/admin-vue/views/PoolsCodes.vue'
import AppBackToListButton from '@morpheus/utils/admin-vue/components/AppBackToListButton.vue'

export default Vue.extend({
  name: 'PoolsShow',
  components: {
    PoolsDetails,
    PoolsCodes,
    AppBackToListButton
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      pool: {},
      showDetails: false
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    fetchPoolById(this.id)
      .then((pool: PoolShowData) => {
        this.pool = pool
        this.showDetails = true
      })
      .catch(error => {
        this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
      })
      .finally(() => {
        this.$store.commit('global/setLoading', false)
      })
  }
})
